import React, {useContext, useState} from 'react'
import PlusIcon from "../../../../statics/assets/icons/plus.svg"
import {SettingTenantDealerContext} from "../../context/SettingTenantDealerContext"
import parseToken from "../../../../helpers/parseToken"
import {Button, DatePicker, Form, Input, message, Modal, Popconfirm, Select} from "antd"
import {addTenantDealer} from "../../../../services/api/apiSetting"
import {_convertArray} from "../../../../helpers/convertArrayToObject"
import {TYPE_TALK_TIME} from "../../../../helpers/enum"

const AddTenantParam = () => {
    const SettingTenantPageContext = useContext(SettingTenantDealerContext)
    const {
        listRoles,
        listNumbers,
        listTypeCampaigns,
        getListSettingTenantDealer
    } = SettingTenantPageContext
    const [form] = Form.useForm();
    const info = parseToken()
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error] = useState('')

    const typeLimitTalkTimeSelect = Form.useWatch('typeLimitTalkTime', form)
    const limitTalkTimeInput = Form.useWatch('limitTalkTime', form)

    const _onToggleModal = () => {
        setIsOpen(!isOpen)
    }

    const _onCancel = () => {
        setIsOpen(false)
        _resetInfo()
    }

    const _resetInfo = () => {
        form.resetFields()
    }

    const onAddTenantDealer = async (payload) => {
        setLoading(true)

        try {
            const response = await addTenantDealer(payload, info.sub)
            const {success, error_message} = response

            if (success !== '1') {
                setLoading(false)
                message.error(error_message)

                return false
            }

            setLoading(false)
            message.success("Thêm mới setting tenant dealer thành công.")
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onSave = async () => {
        await form.validateFields();
        const validationErrors = Object.values(form.getFieldsError());

        if (!validationErrors.find(e => e === undefined)) {
            form.submit()

            setTimeout(() => {
                if (typeof getListSettingTenantDealer === 'function') {
                    getListSettingTenantDealer()
                }
                _onCancel()
            }, 1000)
        }
    }

    const _onSaveAndNew = async () => {
        form.submit()

        setTimeout(() => {
            if (typeof getListSettingTenantDealer === 'function') {
                getListSettingTenantDealer()
            }
            _resetInfo()
        }, 1000)
    }

    const _onSubmitForm = (values) => {
        onAddTenantDealer({
            ...values,
            lstRoleId: _convertArray(values.lstRoleId, 'string')
        })
    }

    return (
        <>
            <button className="ButtonCustom mr-3" onClick={_onToggleModal}>
                <PlusIcon width={12} height={12}/>
                Thêm mới
            </button>
            <Modal
                title="Thêm mới tenant đại lý"
                className="ModalCustom2 FormEdit"
                maskClosable={false}
                visible={isOpen}
                footer={[
                    <div className="Actions d-flex justify-content-end align-items-center">
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={_onCancel}
                                    okText="Yes" cancelText="No">
                            <Button key="back" type="link" disable={loading}>
                                Cancel
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu và tạo mới setting tenant dealer?"
                                    onConfirm={_onSaveAndNew} okText="Yes" cancelText="No">
                            <Button key="submit2" loading={loading}>
                                Save & New
                            </Button>
                        </Popconfirm>
                        <Popconfirm placement="top" title="Bạn chắc chắn muốn lưu setting tenant dealer?"
                                    onConfirm={_onSave}
                                    okText="Yes" cancelText="No">
                            <Button key="submit" type="primary" loading={loading}>
                                Save
                            </Button>
                        </Popconfirm>
                    </div>
                ]}>
                <div className="FormAddNew">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={_onSubmitForm}
                    >
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="tenantName">
                                        Mã Tenant:
                                        <span className="Required">*</span>
                                    </label>
                                    <Form.Item
                                        name='tenantName'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^[a-zA-Z0-9]*$/),
                                                message: "Chỉ chấp nhận chữ và số"
                                            },
                                            {
                                                required: true,
                                                message: "Mã tenant là bắt buộc"
                                            }
                                        ]}
                                    >
                                        <Input/>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="license">
                                        Số lượng user:
                                        <span className="Required">*</span>
                                    </label>
                                    <Form.Item
                                        name='license'
                                        rules={[
                                            {
                                                required: true,
                                                message: "Số lượng user là bắt buộc"
                                            },
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input/>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="lstRoleId">
                                        Danh sách quyền:
                                        <span className="Required">*</span>
                                    </label>
                                    <Form.Item
                                        name='lstRoleId'
                                        rules={[
                                            {
                                                required: true,
                                                message: "Danh sách quyền là bắt buộc"
                                            }
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            optionFilterProp="children"
                                            className="SelectMulti"
                                            mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="Vui lòng chọn"
                                        >
                                            {
                                                listRoles.map((item, index) => (
                                                    <Select.Option key={`parName${index}`} value={item.roleId}>
                                                        {item.roleName}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="lstPhone">
                                        Danh sách đầu số:
                                    </label>
                                    <Form.Item name='lstPhone'>
                                        <Select
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            optionFilterProp="children"
                                            className="SelectMulti"
                                            mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="Vui lòng chọn"
                                        >
                                            {
                                                listNumbers.map((item, index) => (
                                                    <Select.Option key={`parName${index}`} value={item.parValue}>
                                                        {item.parTitle}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="lstCampaignType">
                                        Loại campaign:
                                    </label>
                                    <Form.Item name='lstCampaignType'>
                                        <Select
                                            className="SelectMulti"
                                            mode="multiple"
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="Vui lòng chọn"
                                        >
                                            {
                                                listTypeCampaigns.map((item, index) => (
                                                    <Select.Option key={`parName${index}`} value={item.parValue}>
                                                        {item.parTitle}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="ccuAutoCall">
                                        Giới hạn CCU autocall:
                                    </label>
                                    <Form.Item
                                        name='ccuAutoCall'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input placeholder='Giới hạn CCU autocall'/>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="callRate">
                                        Giới hạn tốc độ quay số:
                                    </label>
                                    <Form.Item
                                        name='callRate'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input placeholder='Tốc độ quay số'/>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="limitTalkTime">
                                        Giới hạn cước (số phút):
                                    </label>
                                    <Form.Item
                                        name='limitTalkTime'
                                        rules={[
                                            {
                                                pattern: new RegExp(/^-?\d*(\.\d*)?$/),
                                                message: "Chỉ chấp nhận số"
                                            },
                                        ]}
                                    >
                                        <Input placeholder='Nhập số phút gọi'/>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="FieldItem">
                                    <label className="Label" htmlFor="typeLimitTalkTime">
                                        Loại tính cước:
                                    </label>
                                    <Form.Item
                                        name='typeLimitTalkTime'
                                        rules={[
                                            limitTalkTimeInput && {
                                                required: true,
                                                message: "Loại tính cước là bắt buộc"
                                            }
                                        ]}
                                    >
                                        <Select
                                            id="typeLimitTalkTime"
                                            name="typeLimitTalkTime"
                                            placeholder="Vui lòng chọn loại tính cước"
                                        >
                                            {
                                                TYPE_TALK_TIME.map((item, index) => (
                                                    <Select.Option key={`parName${index}`} value={item.value}>
                                                        {item.name}
                                                    </Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            {
                                (typeLimitTalkTimeSelect === 'MONTH' || typeLimitTalkTimeSelect === 'BLOCK') &&
                                <div className="col-md-6">
                                    <div className="FieldItem">
                                        <label className="Label" htmlFor="startDateCheckTalkTime">
                                            Thời gian bắt đầu tính cước:
                                        </label>
                                        <Form.Item name='startDateCheckTalkTime'>
                                            <DatePicker
                                                id='startDateCheckTalkTime'
                                                name='startDateCheckTalkTime'
                                                allowClear={true}
                                                format="HH:mm DD/MM/YYYY"
                                                showTime={true}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            }
                            {
                                typeLimitTalkTimeSelect === 'Time' && <div className="col-md-6">
                                    <div className="FieldItem">
                                        <label className="Label" htmlFor="tenantLockTime">
                                            Thời gian khóa cước:
                                        </label>
                                        <Form.Item name='tenantLockTime'>
                                            <DatePicker
                                                id='tenantLockTime'
                                                name='tenantLockTime'
                                                allowClear={true}
                                                format="HH:mm DD/MM/YYYY"
                                                showTime={true}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            }
                        </div>
                    </Form>
                    {error && <div className="text-danger mt-3">{error}</div>}
                </div>
            </Modal>
        </>
    )
}

export default AddTenantParam
